import { ANIMATE_DELAY } from "src/libs/interfaces/animated" 

export const getAnimateDelay = (
    animated_delay: ANIMATE_DELAY | string | number | undefined, 
    i:number = 0
): number | string => {
        switch ( animated_delay) {
            case ANIMATE_DELAY.WATERFALL:
                const ii = ( i || 0) % 6
                return ii === 0 ? "" : ii
            case ANIMATE_DELAY.NONE:
                return ""
            default:
                return animated_delay || ""
        }
    }